import { graphHooks } from '@tunasong/graph-lib/react'
import { MeetingRoom } from '@tunasong/icons'
import cn from 'classnames'
import type { FC } from 'react'
import { useId } from 'react'
import { ListItemIcon, ListItemText, MenuItem, type MenuItemProps } from '@tunasong/ui-lib'
import styles from './room-menu.module.css'

export interface RoomMenuProps extends Omit<MenuItemProps, 'button'> {
  entityId?: string
  open?: boolean
}

/** "Video room". Disabled when nobody else is here, and then it says so, as a visible line and its description. */
export const RoomMenu: FC<RoomMenuProps> = props => {
  const { entityId, open = false, disabled, className, ...restProps } = props
  const { entity } = graphHooks.useEntity(entityId)
  const labelId = useId()
  const reasonId = useId()

  if (!entity) {
    return null
  }

  return (
    <MenuItem
      title={`Video collaboration for ${entity.type}: ${entity.name}`}
      color="inherit"
      className={cn(styles.item, className)}
      disabled={disabled}
      aria-labelledby={labelId}
      aria-describedby={disabled ? reasonId : undefined}
      {...restProps}
    >
      <ListItemIcon className={styles.icon}>
        <MeetingRoom color={open ? 'var(--tuna-palette-secondary-main)' : 'currentColor'} />
      </ListItemIcon>
      <ListItemText
        className={styles.text}
        primary={
          <span id={labelId} className={styles.label}>
            Video room
          </span>
        }
        secondary={
          disabled ? (
            <span id={reasonId} className={styles.reason}>
              No one else is here
            </span>
          ) : undefined
        }
      />
    </MenuItem>
  )
}

export default RoomMenu
